import { auth } from 'boot/firebase';
import { setGlobalOfflineMode, setGlobalOfflineModeAvailable } from 'boot/network';
import { signOut } from 'firebase/auth';
import { BROADCAST_CHANNEL, BROADCAST_MESSAGES } from 'src/constants/broadcastChannel';
import { auth as useAuthStore } from 'src/store/auth';
import { userInterface as useUserInterfaceStore } from 'src/store/userInterface';

export default {

  syncToOnlineLoader(syncToOnline) {
    this.syncToOnlineLoader = syncToOnline;
  }, // syncToOnlineLoader()

  /**
   * @param {BroadcastChannel} broadcastChannel
   */
  setBroadcastChannel(broadcastChannel) {
    this.broadcastChannel = broadcastChannel;
  }, // setBroadcastChannel()

  setupBroadcastChannel(payload) {
    const broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL);
    broadcastChannel.onmessage = async (event) => {
      const { type } = event.data;

      const userInterface = useUserInterfaceStore();
      const authStore = useAuthStore();

      switch (type) {
        case BROADCAST_MESSAGES.TOKEN_REVOCATION_BROADCAST_MESSAGE:
          await authStore.updateUserToken();
          break;
        case BROADCAST_MESSAGES.SYNC_TO_ONLINE_BROADCAST_MESSAGE:
          this.syncToOnlineLoader(true);
          break;
        case BROADCAST_MESSAGES.RELOAD_PAGE_BROADCAST_MESSAGE:
          this.syncToOnlineLoader(false);

          if (process.env.ENV_TYPE !== 'development') {
            window.location.reload();
          }
          break;
        case BROADCAST_MESSAGES.USER_LOGOUT_BROADCAST_MESSAGE:
          sessionStorage.removeItem('selectedClient');

          setGlobalOfflineMode(false);
          setGlobalOfflineModeAvailable(false);

          await signOut(auth);

          if (payload?.context?.$router) {
            await payload.context.$router.replace({ name: 'login' });
          }
          break;
        case BROADCAST_MESSAGES.ENCRYPTION_KEYS_FILLED_BROADCAST_MESSAGE:
          await userInterface.setEncryptionKeysDialogOpen(false);
          break;
        case BROADCAST_MESSAGES.MFA_ENROLLED_BROADCAST_MESSAGE: {
          const router = payload?.context?.$router;
          if (router && router.currentRoute?.value?.path === '/signup/enable-mfa') {
            // Force a full page reload using window.location.assign instead of using routing
            // Using router.push() from inactive tabs leaves stale data in memory,
            // which leads to race conditions and auth state synchronization issues.
            window.location.assign('/');
          } else {
            window.location.reload();
          }
          break;
        }
        case BROADCAST_MESSAGES.CONTINUE_AUTH_SESSION_BROADCAST_MESSAGE:
          authStore.removeAuthSessionNotification();
          break;
        default:
          console.error('Unknown message type', type);
          break;
      }
    };

    this.setBroadcastChannel(broadcastChannel);
  }, // setupBroadcastChannel()

  sendBroadcastMessage(messageType) {
    if (!this.broadcastChannel) {
      this.setupBroadcastChannel();
    }

    return this.broadcastChannel.postMessage({
      type: messageType,
    });
  }, // sendBroadcastMessage()

};
